module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/10HFMRu/images/9781439647011.jpg?1684305909802",
      "alt": "This image is the cover for the book Little Brown Jug: The Michigan-Minnesota Football Rivalry, Images of Sports"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Little Brown Jug: The Michigan-Minnesota Football Rivalry, Images of Sports\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("When the Michigan Wolverines arrived in Minneapolis to battle the Minnesota Gophers in 1903, a simple 30\", five-gallon Red Wing stoneware water jug began football's first rivalry trophy game. The \"Little Brown Jug\" has been the subject of conspiracy theories, theft, national championships, and most of all pride, with each game's victor prominently displaying the jug on its campus--until it is fought for again.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ken Magee, Jon M. Stevens, Glenn E. “Shemy” Schembechler III\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Ken Magee was born and raised in Ann Arbor and is an expert in Wolverine football history. Ken is a 30-year veteran of law enforcement, retired federal agent with the Drug Enforcement Administration, and former chief of police for the University of Michigan. A portion of the proceeds will benefit the Ken Magee Foundation for Cops. The foundation assists police officers who have been permanently injured in the line of duty and their families. Jon M. Stevens was born and raised in Powell, Ohio. Jon made his way to Ann Arbor through his interest in architecture. He earned a master's degree from the University of Michigan and is currently a designer for an architectural firm in downtown Ann Arbor. He is an avid sports memorabilia collector and devoted Michigan Wolverine football fan.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0